import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";

const AddNewAddressScreen = () => {
  const navigate = useNavigate();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [country, setCountry] = useState("Nigeria");
  const [stateRegion, setStateRegion] = useState("Delta");
  const [city, setCity] = useState("Abraka");
  const [street, setStreet] = useState("");

  const handlePhoneChange = (event) => {
    const digitsOnly = event.target.value.replace(/\D/g, "").slice(0, 11);
    setPhone(digitsOnly);
  };

  const isPhoneInvalid = phone.length > 0 && phone.length < 11;

  const isFormValid = () => {
    return (
      firstName.trim() !== "" &&
      lastName.trim() !== "" &&
      phone.length === 11 &&
      country.trim() !== "" &&
      stateRegion.trim() !== "" &&
      city.trim() !== "" &&
      street.trim() !== ""
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const addressPayload = {
      firstName,
      lastName,
      phoneNumber: phone,
      address: street,
      city,
      state: stateRegion,
      country,
      isDefault: true
    };
    const token = localStorage.getItem("userToken");
    fetch(`${process.env.REACT_APP_API_URL}/api/buyers/addresses`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {})
      },
      body: JSON.stringify(addressPayload)
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setTimeout(() => {
            navigate("/address");
          }, 1200);
        } else {
        }
      })
      .catch(() => {
      });
  };

  return (
    <div className="flex flex-col h-screen bg-gray-50">
      <header className="sticky top-0 z-10 bg-white shadow-sm">
        <div className="relative flex h-16 items-center justify-center px-4">
          <button
            type="button"
            onClick={() => setShowCancelModal(true)}
            className="absolute left-4 flex h-10 w-10 items-center justify-center"
            aria-label="Go back"
          >
            <FiArrowLeft className="h-5 w-5 text-gray-800" />
          </button>
          <h1 className="text-base font-bold text-gray-900">Add New Address</h1>
        </div>
      </header>

      <main className="flex-1 overflow-y-auto p-4 pb-24">
        <form onSubmit={handleSubmit} className="rounded-xl bg-white p-4 shadow-sm">
          <div className="grid gap-4">
            <div>
              <label className="text-sm font-medium text-gray-700">First Name</label>
              <input
                type="text"
                value={firstName}
                onChange={(event) => setFirstName(event.target.value)}
                className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#19C463]"
              />
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">Last Name</label>
              <input
                type="text"
                value={lastName}
                onChange={(event) => setLastName(event.target.value)}
                className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#19C463]"
              />
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">Phone Number</label>
              <input
                type="text"
                value={phone}
                onChange={handlePhoneChange}
                maxLength={11}
                className={`mt-2 w-full rounded-lg border px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#19C463] ${
                  isPhoneInvalid ? "border-red-500" : "border-gray-200"
                }`}
              />
              {isPhoneInvalid && (
                <p className="mt-1 text-xs text-red-500">Input right phone number</p>
              )}
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">Country/Region</label>
              <select
                value={country}
                onChange={(event) => setCountry(event.target.value)}
                disabled
                className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-gray-100"
              >
                <option>Nigeria</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">State</label>
              <select
                value={stateRegion}
                onChange={(event) => setStateRegion(event.target.value)}
                disabled
                className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-gray-100"
              >
                <option>Delta</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">City</label>
              <select
                value={city}
                onChange={(event) => setCity(event.target.value)}
                disabled
                className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm bg-gray-100"
              >
                <option>Abraka</option>
              </select>
            </div>

            <div>
              <label className="text-sm font-medium text-gray-700">Street Address</label>
              <input
                type="text"
                value={street}
                onChange={(event) => setStreet(event.target.value)}
                className="mt-2 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#19C463]"
              />
            </div>
          </div>
        </form>
      </main>

      <div className="fixed bottom-0 left-0 right-0 bg-gray-50 p-4">
        <button
          type="submit"
          onClick={handleSubmit}
          disabled={!isFormValid()}
          className={`w-full rounded-lg py-3 text-sm font-medium text-white ${
            isFormValid() ? "bg-[#19C463]" : "bg-[#AAAAAA]"
          }`}
        >
          Add New Address
        </button>
      </div>

      {showCancelModal && (
        <div className="fixed inset-0 z-40 flex items-center justify-center bg-black bg-opacity-[15%] backdrop-blur-[7px]">
          <div className="relative w-full max-w-sm rounded-xl bg-white p-6 z-50">
            <p className="text-center text-sm font-semibold text-gray-900">
              Are you sure you want to cancel
            </p>
            <div className="mt-6 flex items-center gap-3">
              <button
                type="button"
                onClick={() => setShowCancelModal(false)}
                className="flex-1 rounded-lg bg-red-500 py-3 text-sm font-semibold text-white"
              >
                No
              </button>
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="flex-1 rounded-lg bg-[#19C463] py-3 text-sm font-semibold text-white"
              >
                Yes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddNewAddressScreen;
